<template>
    <div>
        <label for="password" class="font-medium text-gray-500 dark:text-gray-400" :class="label_class">{{ label }}</label>
        <input
            :name="name"
            :placeholder="placeholder"
            :value="modelValue"
            :class="input_class"
            :id="id"
            @input="$emit('update:modelValue', $event.target.value)" 
            type="password"
            class="block w-full flex-1 border rounded-md px-3 py-2 text-gray-700 dark:text-gray-200 placeholder:text-gray-400 focus:outline-none focus:ring focus:ring-color-5 sm:text-sm sm:leading-6 bg-white dark:bg-dark-900">
    </div>
</template>

<script>
export default {
    name: 'InputPassword',
    props: {
        label: String,
        label_class: String,
        id: String,
        name: String,
        placeholder: String,
        modelValue: String,
        input_class: String
    },
    emits: ['update:modelValue'],
}
</script>